
import { ROUTE_OPERATOR_PAGE_API } from './../../config/apiPoints';
import { fetchHelper } from './../../../utils/fetchHelper';
import getDateObj from './../../Common/utils/GetDateObj';

export const prepareRouteOperatorPageRequest = (params) => {
  const { src, dest, operator, operatorId } = params;
  let slug = `${operator}-buses-from-${src}-to-${dest}-online-booking${operatorId ? '-' + operatorId : ''}`;
  const url = `${__ENV_CONFIG__.__PAGEROVER__}${ROUTE_OPERATOR_PAGE_API}?slug=${slug}`
  return url;
}

export const getRouteOperatorPageData = async (params) => {
  const url = prepareRouteOperatorPageRequest(params);
  let data = {}
  try {
    data = await fetchHelper({
      name: 'route operator page',
      type: 'GET',
      url: url,
    });
  } catch (err) {
    data = { status: false, error: true }
  }
  return data;

}

export const getRouteOperatorKey = (src, dest, operatorName, operatorId, str, bus_type = "") => {
  const date = getDateObj();
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2);

  return `bus_mweb_route_operator${src ? `_${src}` : ''}${dest ? `_${dest}` : ''}${operatorName ? `_${operatorName}` : ''}${bus_type ? `_${bus_type}` : ''}${operatorId ? `_${operatorId}` : ''}_${year}-${month}-${day}${str ? `_${str}` : ''}`;
}